export type SpaceStatus = "draft" | "active" | "archived";

export type FileRole = "reference" | "source" | "generated" | "attachment";

export type SpaceRole = "owner" | "collaborator" | "superadmin";

export interface SpaceCaseMini {
  id: number;
  key: string;
  label: string;
  description?: string | null;
  icon?: string | null;
  color?: string | null;
}

export interface SpaceCaseTemplateMini {
  id: number;
  key: string;
  name: string;
  description?: string | null;
  supportedFormats: string[];
}

export interface SpaceOutputSkin {
  fileId: number;
  name: string;
  extension: string;
  role: string;
  uploadedAt?: string | null;
}

export interface Space {
  id: number;
  name: string;
  description?: string;
  status: SpaceStatus;
  metadata_?: Record<string, unknown>;
  uuid?: string;
  owner: {
    id: number;
    email: string;
    firstname?: string;
    lastname?: string;
  };
  category?: {
    id: number;
    name: string;
  };
  documentTemplateId?: number | null;
  caseId?: number | null;
  case?: SpaceCaseMini | null;
  caseTemplates?: SpaceCaseTemplateMini[] | null;
  fileCount?: number;
  /** Rol del usuario actual en el espacio. null si no tiene acceso (no debería verlo igual). */
  myRole?: SpaceRole | null;
  /**
   * Cuando true, todas las llamadas al LLM (Forja, Chat, Wiki, agents del graph,
   * clasificador) originadas en este espacio pasan por LlmGateway con
   * anonimización PII: nombres/DNI/CIF/teléfonos/emails/etc. se sustituyen por
   * marcadores antes de enviar al proveedor externo y se restauran en la
   * respuesta. Default false. Opt-in explícito por el propietario del espacio.
   */
  anonymizeLlm: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface SpaceMember {
  userId: number;
  email: string;
  fullName?: string | null;
  role: "owner" | "collaborator";
  addedAt?: string | null;
}

export interface SpaceCreate {
  name: string;
  description?: string;
  categoryId?: number;
  documentTemplateId?: number;
  caseId?: number;
  metadata_?: Record<string, unknown>;
}

export interface SpaceUpdate {
  name?: string;
  description?: string;
  status?: SpaceStatus;
  categoryId?: number;
  documentTemplateId?: number;
  caseId?: number | null;
  metadata_?: Record<string, unknown>;
  anonymizeLlm?: boolean;
}

export interface SpaceListResponse {
  items: Space[];
  total: number;
  page: number;
  page_size: number;
}

export interface SpaceSection {
  id: number;
  spaceId: number;
  sectionType: string;
  title?: string;
  content?: string;
  sectionMetadata?: Record<string, unknown>;
  createdAt: string;
  updatedAt?: string;
}

export const SPACE_STATUS_LABELS: Record<SpaceStatus, string> = {
  draft: "Borrador",
  active: "Activo",
  archived: "Archivado",
};

export const FILE_ROLE_LABELS: Record<FileRole, string> = {
  reference: "Referencia",
  source: "Fuente de información",
  generated: "Forja de Documentos",
  attachment: "Adjunto",
};
